import React from 'react';

const testimonials = [
  {
    id: 1,
    name: 'Elias Mureithi',
    quote: 'TGL Credit Limited provided fast and reliable financing for my business. Their team was professional and supportive throughout.',
    role: 'Entrepreneur',
    avatar: '/assets/images/testimonials/avatar.png',
  },
  {
    id: 2,
    name: 'Everline Odoyo',
    quote: 'The logbook loan process was seamless, and the terms were clear. I highly recommend TGL for their transparency.',
    role: 'Small Business Owner',
    avatar: '/assets/images/testimonials/avatar.png',
  },
  {
    id: 3,
    name: 'Shammah Bushuru',
    quote: 'TGL’s medical insurance gave my family peace of mind. Their customer service is top-notch!',
    role: 'Family Provider',
    avatar: '/assets/images/testimonials/avatar.png',
  },
  {
    id: 4,
    name: 'Mbitu James',
    quote: 'TGL’s asset financing helped me expand my fleet with ease. Their flexible terms made all the difference.',
    role: 'Transport Business Owner',
    avatar: '/assets/images/testimonials/mbitu.jpg',
  },
  {
    id: 5,
    name: 'Emmanuel Kirya',
    quote: 'With TGL’s support, I secured a loan that transformed my startup. Their team truly cares about client success.',
    role: 'Tech Entrepreneur',
    avatar: '/assets/images/testimonials/emmanuel.jpg',
  },
];

const Testimonials = ({ limit = testimonials.length }) => {
  return (
    <section className="bg-white py-20 sm:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-24">
        <h2 className="text-[26px] font-inter font-bold text-maasai-blue text-center mb-6 animate-fade-up">
          <span className="group inline-block relative">
            <span className="underline decoration-maasai-red decoration-3">
              What Our
            </span>
            <span className="absolute bottom-0 left-0 w-0 h-1 bg-maasai-red transition-all duration-300 group-hover:w-full" />
          </span>{' '}
          Clients Say
        </h2>
        <p className="text-sm font-inter font-medium text-gray-600 text-center mb-12 max-w-3xl mx-auto animate-fade-up" style={{ animationDelay: '0.2s' }}>
          Hear from our satisfied clients about their experiences with TGL Credit Limited’s trusted financial solutions.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {testimonials.slice(0, limit).map((testimonial, index) => (
            <div
              key={testimonial.id}
              className="bg-white rounded-lg shadow-lg hover:-translate-y-2 hover:shadow-2xl hover:border-maasai-red border border-transparent transition-all duration-300 p-8 animate-slide-in-right"
              style={{ animationDelay: `${0.4 + index * 0.2}s`, willChange: 'transform, box-shadow, border-color' }}
            >
              <div className="flex items-center mb-6">
                <img
                  src={testimonial.avatar}
                  alt={`${testimonial.name} avatar`}
                  className="w-14 h-14 rounded-full object-cover mr-4 border border-maasai-red/20"
                  loading="lazy"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextElementSibling.style.display = 'flex';
                    console.error(`Failed to load image: ${testimonial.avatar}`);
                  }}
                />
                <div className="w-14 h-14 rounded-full bg-maasai-red flex items-center justify-center text-white font-inter text-2xl mr-4 hidden">
                  {testimonial.name.charAt(0)}
                </div>
                <div>
                  <h3 className="text-xl font-inter font-semibold text-maasai-blue">
                    {testimonial.name}
                  </h3>
                  <p className="text-sm font-inter font-medium text-gray-500">{testimonial.role}</p>
                </div>
              </div>
              <p className="text-sm font-inter text-gray-700 italic leading-relaxed">
                "{testimonial.quote}"
              </p>
            </div>
          ))}
        </div>
      </div>
      <style>
        {`
          @keyframes slide-in-right {
            from { opacity: 0; transform: translateX(50px); }
            to { opacity: 1; transform: translateX(0); }
          }
          .animate-slide-in-right {
            animation: slide-in-right 0.8s ease-in-out forwards;
            will-change: transform, opacity;
          }
          @keyframes fade-up {
            from { opacity: 0; transform: translateY(15px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .animate-fade-up {
            animation: fade-up 0.8s ease-in-out forwards;
            will-change: transform, opacity;
          }
          @media (prefers-reduced-motion: reduce) {
            .animate-slide-in-right, .animate-fade-up, .hover\\:-translate-y-2, .hover\\:shadow-2xl, .group-hover\\:w-full {
              animation: none !important;
              transform: none !important;
              transition: none !important;
            }
          }
        `}
      </style>
    </section>
  );
};

export default Testimonials;